<template>
  <layout-main-inner title="商品统计">
    <layout-card-wrap v-loading="loading"
      hasHeaderSlot>
      <template slot="title">全期数据</template>
      <summary-list :span="userPermission.SUPERVISE || userPermission.OPERATE ? 6 : 8"
        :list="summaryList" />
      <summary-list style="margin-top:15px"
        :span="userPermission.SUPERVISE || userPermission.OPERATE ? 6 : 8"
        :list="summaryList1" />
    </layout-card-wrap>
    <layout-card-wrap style="margin-top:15px"
      hasHeaderSlot
      v-loading="loading">
      <template slot="title">按周期统计</template>
      <template slot="form">
        <product-form :callBack="getproductstats" />
      </template>
      <summary-list :span="userPermission.SUPERVISE || userPermission.OPERATE ? 6 : 8"
        :list="summaryRangeList" />
      <summary-list :span="userPermission.SUPERVISE  || userPermission.OPERATE ? 6 : 8"
        :list="summaryRangeList1" />
      <el-card shadow="never"
        style="margin-top:15px">
        <e-charts :options="options"
          :init-options="{}"
          ref="charts"
          autoresize />
      </el-card>
      <el-table style="margin-top:15px"
        v-if="userPermission.ENT || curent.vendorId"
        border
        :data="list">
        <el-table-column label="商品名称"
          prop="productName">
        </el-table-column>
        <el-table-column label="上线商品数量"
          width="200"
          prop="goodsCount">
        </el-table-column>
        <el-table-column label="批次数量"
          width="200"
          prop="batchCount">
        </el-table-column>
      </el-table>
      <el-table style="margin-top:15px"
        v-if="(userPermission.SUPERVISE || userPermission.OPERATE) && !curent.vendorId"
        border
        :data="vList">
        <el-table-column label="企业名称"
          prop="vendorName">
        </el-table-column>
        <el-table-column label="上线商品数量"
          width="200"
          prop="goodsCount">
        </el-table-column>
        <el-table-column label="批次数量"
          width="200"
          prop="batchCount">
        </el-table-column>
        <el-table-column label="报关批次数量"
          prop="inspectCount">
        </el-table-column>
        <el-table-column label="报关货批数量"
          prop="inspectProductCount">
        </el-table-column>
        <el-table-column label="报关商品数"
          prop="inspectGoodsCount">
        </el-table-column>
      </el-table>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import ProductForm from './busi/product-form.vue'
import SummaryList from './busi/summary.vue'
import ECharts from '@/components/public/ECharts.vue'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import moment from 'moment'
import { mapState } from 'vuex'
import clonedeep from 'lodash.clonedeep'
export default {
  name: 'stat-product',
  components: { SummaryList, ECharts, ProductForm },
  data () {
    return {
      curent: {},
      loading: false,
      list: [],
      vList: [],
      summaryList: [],
      summaryList1: [],
      summaryRangeList: [],
      summaryRangeList1: [],
      options: {
        title: {
          text: '商品批次/数量折线图',
          textStyle: {
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: 100,
          top: 60,
          right: 60,
          bottom: 60
        },
        legend: {
          data: ['批次数量', '上线商品'],
          top: 'bottom'
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} 件'
          }
        },
        series: [
          {
            name: '批次数量',
            data: [],
            type: 'line',
            label: {
              normal: {
                show: true,
                position: 'top'
              }
            }
          },
          {
            name: '上线商品',
            data: [],
            type: 'line',
            label: {
              normal: {
                show: true,
                position: 'top'
              }
            }
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  methods: {
    getproductstats (payload) {
      this.loading = true
      this.curent = clonedeep(payload)
      this.$store.dispatch('stat/getproductstats', {
        payload,
        success: (res) => {
          this.loading = false
          this.summaryList = [
            {
              label: '商品备案数量',
              value: res.data.totalProductCount
            },
            {
              label: '批次数量',
              value: res.data.totalBatchCount
            },
            {
              label: '上线商品数量',
              value: res.data.totalGoodsCount
            }
          ]
          this.summaryList1 = [
            {
              label: '报关批次数量',
              value: res.data.totalInspectCount
            },
            {
              label: '报关货批数量',
              value: res.data.totalInspectProductCount
            },
            {
              label: '报关商品数',
              value: res.data.totalInspectGoodsCount
            }
          ]
          this.summaryRangeList = [
            {
              label: '商品备案数量',
              value: res.data.productCount
            },
            {
              label: '批次数量',
              value: res.data.batchCount
            },
            {
              label: '上线商品数量',
              value: res.data.goodsCount
            }
          ]
          this.summaryRangeList1 = [
            {
              label: '报关批次数量',
              value: res.data.inspectCount
            },
            {
              label: '报关货批数量',
              value: res.data.inspectProductCount
            },
            {
              label: '报关商品数',
              value: res.data.inspectGoodsCount
            }
          ]
          if (this.userPermission.SUPERVISE || this.userPermission.OPERATE) {
            this.summaryList = [
              {
                label: '企业备案数量',
                value: res.data.totalVendorCount
              },
              ...this.summaryList
            ]
            this.summaryList1 = [
              {
                label: '报关企业数量',
                value: res.data.totalInspectVendorCount
              },
              ...this.summaryList1
            ]
            this.summaryRangeList = [
              {
                label: '企业备案数量',
                value: res.data.vendorCount
              },
              ...this.summaryRangeList
            ]
            this.summaryRangeList1 = [
              {
                label: '报关企业数量',
                value: res.data.inspectVendorCount
              },
              ...this.summaryRangeList1
            ]
          }
          this.list = res.data.productStatsInfos
          this.vList = res.data.vendorStatsInfos
          let xAxisData = res.data.monthlyGoodsInfos.map(o => moment(o.month, 'YYYYMM').format('YYYY/MM'))
          let series1 = res.data.monthlyGoodsInfos.map(o => o.batchCount)
          let series2 = res.data.monthlyGoodsInfos.map(o => o.goodsCount)
          this.options.xAxis.data = xAxisData
          this.options.series[0].data = series1
          this.options.series[1].data = series2
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
